import React from 'react';
import styled from 'styled-components';
import Input from './Input';
import { theme } from '../theme';
import { DropdownOverlay, FooterOption } from '../styles';
import debounce from 'lodash/debounce';
import TickIcon from '../../../../images/common/check-fill-green.svg';
// import TickIcon from "../../../../../images/common/tick-green.svg";

interface IStyleProps {
  fontSize?: string;
  width?: string;
}
const { text, border } = theme.palette;

const InputWrapper = styled.div<IStyleProps>`
  position: relative;
  width: ${props => props.width || '300px'};
  font-size: ${props => props.fontSize || '16px'};
  li {
    font-size: ${props => props.fontSize || '16px'};
  }
  .options-menu {
    .input-wrapper .searchable-dropdown-input {
      padding: 0px !important;
    }
    &.dpdn-with-search {
      padding: 1px !important;
    }
  }
  &.dpdn-no-border {
    border: none;
    width: auto;
    min-width: 50px;
    display: inline-block;
    .header {
      border: none;
      width: auto;
      min-width: 50px;
      height: auto;
      padding: 0px 10px;
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
    }
    .select-header-icon {
      border-left: none;
      position: unset;
      height: auto;
      width: auto;
    }
    .options-menu {
      border: none;
      overflow-x: hidden;
      transform: translate(5px, 25px);
      padding-right: 0px;
      > div {
        overflow-x: hidden;
      }
    }
    &.text-royal-blue {
      .header,
      .select-header-icon,
      .options-menu li {
        color: #556bb8;
      }
    }
  }
  &.dpdn-with-icons {
    min-width: 210px;
    width: auto;
    max-width: 350px;
    .header {
      min-width: 210px;
      width: auto;
      max-width: 350px;
    }
    .select-header-icon {
      border-left: none;
      color: #aaa;
    }
    .options-menu {
      border: 1px solid #aaa;
      border-radius: 4px;
    }
    &.item-selected-dropdown {
      .header {
        width: 430px;
        max-width: 450px;
      }
      .options-menu {
        width: 430px;
        max-width: 450px;
      }
    }
  }
  &.dpdn-no-separator {
    .select-header-icon {
      border-left: none;
    }
  }
  &.dpdn-with-footer {
    .options-menu {
      padding: 10px 0px 0px;

      .searchable-dropdown-input {
        padding-left: 15px !important;
        font-size: 16px;
        &::placeholder {
          font-size: 16px;
        }
      }
      &.no-options {
        .options-menu {
          padding: 0px !important;
        }
      }
    }
  }
  .new-payment-option {
    color: #556bb8;
    background-color: #f8f8f8;
    padding: 10px 16px;
    img {
      height: 18px;
      width: 18px;
      margin-right: 10px;
    }
  }
  &.dropup {
    .options-menu {
      top: unset;
      bottom: 0;
      transform: translate(0px, -50px);
      border-radius: 4px;
    }
    .select-header-icon i.fa.fa-solid.fa-caret-down {
      transform: rotate(180deg);
    }
  }
  &.default-dpdn {
    .select-header-span {
      color: #555;
    }
  }
  &.default-padding-search-dpdn {
    .options-menu.dpdn-with-search {
      .searchable-dropdown-input {
        padding-left: 12px !important;
      }
      li {
        padding: 0px 12px !important;
      }
    }
  }
  &.select-overflowed-ellipsis {
    text-overflow: ellipsis;
    // overflow: hidden;
    white-space: nowrap;
    width: 100%;
  }
`;

const DropdownInput = styled.div<IStyleProps>`
  height: 40px;
  width: ${props => props.width || '300px'};
  border: 1px solid ${border.darker};
  border-radius: 4px;
  padding: 6px 7px;
  color: ${text.main};
  position: relative;
  .select-header-icon {
    position: absolute;
    top: 0%;
    right: 0;
    transform: translate(0px, 2px);
    height: 34px;
    width: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: 1px solid ${border.dark};
    i {
      margin-left: 0 !important;
      font-size: 23px;
    }
  }
  .select-header-span {
    display: block;
    padding: 0px 6px;
    width: 100%;
  }
`;
const DropdownOption = styled.div`
  max-height: 130px;
  overflow-y: auto;
  cursor: pointer;
  width: 100%;
  li {
    list-style-type: none;
    font-weight: 400;
    color: ${text.main};
    line-height: 25px;
    cursor: pointer;
  }
  label {
    cursor: pointer;
  }
  &::-webkit-scrollbar {
    width: 0.4em;
    height: 0.4em;
    background-color: rgb(232, 234, 235);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    outline: 1px solid #ddd;
    background-color: rgba(21, 40, 55, 0.3);
    border-radius: 10px;
  }

  li,
  .dropdown-option > div {
    &:hover {
      /* background-color: #9e9e9e26; */
      background-color: #f8f8f8;
      cursor: pointer;
    }
  }
`;

type IProps = {
  options: any[][];
  selectedKey: string | number | boolean | string[];
  nameKeys: string[] | ['name'];
  valueKeys: string[] | ['value'];
  hasError?: boolean;
  errorMessage?: string | '';
  emptySelection: string | 'Select' | React.ReactNode;
  searchKeys?: string[] | [];
  searchable?: boolean;
  className?: string;
  fontSize?: string;
  onChange?: (opt: any, searchValue?: string) => any;
  customHeader?: React.ReactNode;
  customOption?: (opt: any, searchValue: string) => React.ReactNode;
  disabled?: boolean;
  width?: string;
  customFooter?: React.ReactNode;
  footerClass?: string;
  placeholder?: string;
  searchPlaceholder?: string;
  hasMoreRecords?: boolean;
  loadData?: (searchValue: string) => void;
  onSearch?: (searchValue: string) => void;
};
const defaultProps = {
  emptySelection: 'Select',
  searchable: false,
  hasError: false,
};

type IState = {
  searchValue: string;
  showOptions: boolean;
};

export default class SingleSelect extends React.Component<IProps, IState> {
  static defaultProps = defaultProps;
  wrapperRef = React.createRef<HTMLDivElement>();
  inputRef: HTMLInputElement | null = null;
  constructor(props: IProps) {
    super(props);
    this.state = {
      searchValue: '',
      showOptions: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event: any) {
    if (this.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
      this.toggleMenu(false);
    }
  }

  onSearch(value: string) {
    if (value === this.state.searchValue) {
      return; // Avoid unnecessary state updates and debounce calls
    }
    this.setState(
      {
        searchValue: value,
      },
      () => {
        this.debounceSearch(value);
      }
    );
  }

  debounceSearch = debounce((value: string) => {
    this.state.showOptions && this.props.onSearch?.(value);
  }, 300);

  setInputRef = (el: HTMLInputElement | null) => {
    this.inputRef = el;
    if (this.inputRef) {
      this.inputRef.focus();
    }
  };

  get searchBox(): React.ReactNode {
    const { searchable, disabled, searchPlaceholder } = { ...this.props };
    if (!searchable) return null;
    return (
      <Input
        ref={this.setInputRef}
        type="text"
        disabled={disabled}
        placeholder={searchPlaceholder}
        onChange={e => this.onSearch(e.target.value.toLowerCase())}
        className="searchable-dropdown-input"
        onKeyDown={e => {
          if (e.key === 'Tab') {
            this.toggleMenu(false);
          }
        }}
        // content="/f002"
      />
    );
  }

  get header(): React.ReactElement {
    const {
      options,
      selectedKey,
      nameKeys,
      valueKeys,
      emptySelection,
      hasError,
      customHeader,
      errorMessage,
      disabled,
      width,
    } = this.props;
    let headerValue: any = '';
    options.map((opts, idx) => {
      const matchedOption = opts.find(x => x[valueKeys[idx]] === selectedKey);
      if (matchedOption) {
        headerValue = matchedOption?.[nameKeys[idx]];
      }
    });

    const className = hasError ? 'error-border' : '';
    const isPlaceholder = !headerValue;

    return (
      <>
        <DropdownInput
          width={width}
          className={`header ${className} ${isPlaceholder ? 'is-placeholder' : ''}`}
          onClick={() => !disabled && !this.state.showOptions && this.toggleMenu(true)}
          tabIndex={0}
          onFocus={() => !disabled && this.toggleMenu(true)} // <-- open on tab focus
          // onKeyDown={(e) => {
          //   if (e.key === "Enter" || e.key === " ") {
          //     e.preventDefault();
          //     !disabled && this.toggleMenu(!this.state.showOptions);
          //   }
          //   if (e.key === "Escape") {
          //     this.toggleMenu(false);
          //   }
          //   if (e.key === "Tab") {
          //     this.toggleMenu(false);
          //   }
          // }}
        >
          <span
            className={`select-header-span ${emptySelection ? 'select-placeholder-only' : ''}`}
            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
          >
            {' '}
            {customHeader || headerValue || emptySelection}
          </span>
          <div className="select-header-icon" style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
            <i className="fa fa-solid fa-caret-down"></i>
          </div>
        </DropdownInput>
        {hasError && errorMessage && <p className="error-message">{errorMessage}</p>}
      </>
    );
  }

  toggleMenu(show: boolean) {
    if (this.state.searchValue) {
      this.props.onSearch?.('');
    }
    const searchValue = show ? this.state.searchValue : '';
    this.setState({
      showOptions: show,
      searchValue,
    });
  }

  escapeRegexCharacters(str: string) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  get optionMenu(): React.ReactElement {
    const { options, searchKeys, nameKeys, customOption, disabled, customFooter, footerClass } = this.props;
    const { searchValue, showOptions } = this.state;
    if (!showOptions || disabled) return <></>;

    let matchedOptions: any = [];
    if (searchValue && options) {
      const escapedValue = this.escapeRegexCharacters(searchValue.trim().toString().toLowerCase());
      if (escapedValue === '') {
        matchedOptions = [];
      } else {
        // const regex = new RegExp('\\b' + escapedValue, 'i');
        matchedOptions = options.map((opts, index) => {
          const matchedcOptions = opts.filter(option => {
            const value =
              searchKeys && searchKeys?.length >= index ? option[searchKeys[index]] : option[nameKeys[index]];
            return value?.toString().toLowerCase()?.includes(searchValue);
          });
          return matchedcOptions;
        });
      }
    } else {
      matchedOptions = options;
    }

    const { searchable } = this.props;
    return (
      <DropdownOverlay className={`options-menu ${searchable ? 'dpdn-with-search' : ''}`}>
        {this.searchBox}
        <DropdownOption className="dropdown-option-list" onScroll={event => this.handleScroll(event)}>
          {matchedOptions.map((opts: any, idx: number) => {
            return opts.map((opt: any, index: number) => {
              if (customOption) {
                return (
                  <div key={index} onClick={() => this.onChange(opt)} className="dropdown-option">
                    {customOption(opt, this.state.searchValue)}
                  </div>
                );
              }
              return (
                <>
                  <li onClick={() => this.onChange(opt)} key={index}>
                    {opt[nameKeys[idx]]}
                    {opt.isDefault && (
                      <img
                        src={TickIcon}
                        alt="Selected"
                        style={{
                          height: '13px',
                          width: '13px',
                          marginLeft: '7px',
                          marginBottom: '2px',
                        }}
                      />
                    )}
                  </li>
                </>
              );
            });
          })}
        </DropdownOption>
        {customFooter && <FooterOption className={footerClass}>{customFooter}</FooterOption>}
      </DropdownOverlay>
    );
  }

  onChange(opt: any) {
    this.props.onChange && this.props?.onChange(opt, this.state.searchValue);
    this.toggleMenu(false);
  }

  handleScroll(event: React.UIEvent<HTMLDivElement>) {
    if (!this.props.hasMoreRecords) {
      return;
    }
    const target = event.currentTarget;
    const scrollPosition = target.scrollHeight - target.scrollTop;
    const clientHeight = target.clientHeight + 1;
    const isEndOfScroll = scrollPosition <= clientHeight;
    if (isEndOfScroll) {
      this.props.loadData && this.props.loadData(this.state.searchValue);
    }
  }

  render(): React.ReactNode {
    return (
      <InputWrapper
        width={this.props.width}
        ref={this.wrapperRef}
        className={`single-select-wrapper ${this.props.className} ${this.props.footerClass ? 'dpdn-with-footer' : ''} ${this.props.options.length > 0 ? '' : 'no-options'} `}
        // add class dpdn-no-border to remove border
        // add class dpdn-no-separator to remove separator with icon
        // add class dpdn-with-icons to add icons
        // add  dropup to show dropdown above
        // add  footerClass="new-payment-option" to add new payment option
        // add  className="default-padding-search-dpdn" to add padding to search dropdown

        fontSize={this.props.fontSize}
      >
        {this.header}
        {this.optionMenu}
      </InputWrapper>
    );
  }
}

SingleSelect.defaultProps = defaultProps;
